import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 60000 });

export const fetchIPOs = async () => (await client.get("/ipos")).data;

export const generateTierList = async (ipo) =>
  (await client.post("/tier-list", {
    ipo_name: ipo.name,
    sector: ipo.sector,
    blurb: ipo.blurb,
  })).data;

export const deepDive = async ({ ticker, company, ipo_name }) =>
  (await client.post("/ticker/deep-dive", { ticker, company, ipo_name })).data;

export const analyzeTicker = async ({ ticker, ipo_name }) =>
  (await client.post("/ticker/analyze", { ticker, ipo_name })).data;
